module.exports = __webpack_public_path__ + "img/sale4.902176ee.png";